/**
 * Feature Flags Configuration
 * Controls which features are enabled/disabled in the application
 */

const features = {
  /**
   * Open Evidence Integration
   * When enabled, shows the OE connection option in Settings > Integrations
   * Requires backend API endpoints and browser automation
   *
   * Status: DISABLED - Pending official API access from OpenEvidence
   * Contact: contact@openevidence.com for API inquiry
   */
  OPEN_EVIDENCE_INTEGRATION: false,

  /**
   * Future feature flags can be added here
   */
} as const

type FeatureFlag = keyof typeof features

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return features[flag]
}
